/* Rundis theme: reviews sorting + "show more" (client-side, no extra requests). */
(() => {
  'use strict';
  class ReviewsList extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-reviews-list]');
      if (!this.list) return;
      this.items = Array.from(this.list.querySelectorAll('[data-review]'));
      this.per = Number(this.dataset.perPage) || 6;
      this.shown = this.per;
      this.more = this.querySelector('[data-reviews-more]');
      this.sort = this.querySelector('[data-reviews-sort]');
      if (this.sort) this.sort.addEventListener('change', () => this.apply());
      if (this.more) {
        this.more.addEventListener('click', () => {
          const first = this.shown;
          this.shown += this.per;
          this.render();
          const next = this.items[first];
          if (next) { next.setAttribute('tabindex', '-1'); next.focus(); }
        });
      }
      this.apply();
    }

    apply() {
      const mode = this.sort ? this.sort.value : 'default';
      const lang = this.dataset.lang;
      const byDate = (a, b) => (b.dataset.date || '').localeCompare(a.dataset.date || '');
      const rating = (el) => Number(el.dataset.rating) || 0;
      const sorted = [...this.items].sort((a, b) => {
        if (mode === 'newest') return byDate(a, b);
        if (mode === 'highest') return rating(b) - rating(a) || byDate(a, b);
        if (mode === 'lowest') return rating(a) - rating(b) || byDate(a, b);
        const la = a.dataset.lang === lang ? 0 : 1;
        const lb = b.dataset.lang === lang ? 0 : 1;
        return la - lb || byDate(a, b);
      });
      sorted.forEach((el) => this.list.appendChild(el));
      this.items = sorted;
      this.shown = this.per;
      this.render();
    }

    render() {
      this.items.forEach((el, i) => { el.hidden = i >= this.shown; });
      if (this.more) this.more.hidden = this.shown >= this.items.length;
    }
  }
  if (!customElements.get('reviews-list')) customElements.define('reviews-list', ReviewsList);
})();
